import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import style from './style.css';

export default class ListItem extends React.Component {

  static propTypes = {
    item : PropTypes.object,
    selected : PropTypes.bool,
    onEvent : PropTypes.func
  }

  onEvent( event ) {
    if ( this.props.onEvent && this.props.item ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const { titleClass = '', subtitleClass = '', areaClass = '', titleAreaClass = '', rootClick } = this.props
    const item = this.props.item;
    const selected = this.props.selected === true;
    let title = null;
    let subtitle = null;
    const header = null;
    const rightChild = this.props.rightView;
    const leftChild = this.props.leftView;

    if ( this.props.title ) {
      title = <div className={classNames( style.listItemTitle, titleClass )}>{this.props.title}</div>
    } 
    if ( this.props.subtitle ) {
      subtitle = <div className={classNames( style.listItemSubtitle, subtitleClass )}>{this.props.subtitle}</div>
    }

    const clazz = classNames( style.listItem, this.props.className, selected ? style.selected : null );

    return (
      <div className={clazz} onClick={rootClick ? () => { this.onEvent( 'select' ) } : null}>
        <div className={classNames( style.listItemArea, areaClass )}>
          {leftChild}
          <div className={classNames( style.listItemTitleArea, titleAreaClass )} onClick={!rootClick ? () => { this.onEvent( 'select' ) } : null}>
            {title}
            {subtitle}
          </div>
          {rightChild}
        </div>
        {this.props.children}
      </div>
    )
  }
}
